import { useMutation, useQueryClient } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useDeleteAnnouncement () {
  const queryClient = useQueryClient()

  return useMutation(
    async (announcementId) => {
      const deletedAnnouncement = await axios.delete(`${getApiServer()}/announcements/${announcementId}`, { withCredentials: true })
      return deletedAnnouncement.data
    },
    {
      onMutate: (values) => {
        const announcements = queryClient.getQueryData('announcements')
        queryClient.setQueryData('announcements', announcements.filter((announcement) => announcement.id !== values))
      },
      onSuccess: async () => {
        await queryClient.refetchQueries('announcements')
      }
    }
  )
}